import React from 'react';

const AdminPlaceholderPage = ({ title, summary }) => (
  <section className="cq-admin-page">
    <header className="cq-admin-page__header">
      <div>
        <p className="cq-admin-page__eyebrow">Admin Module</p>
        <h2 className="cq-admin-page__title">{title}</h2>
      </div>
    </header>
    <div className="cq-admin-empty-state">
      <p className="cq-admin-empty-state__title">{title} is not built yet.</p>
      <p className="cq-admin-empty-state__copy">{summary}</p>
    </div>
  </section>
);

export default AdminPlaceholderPage;
